import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";
import { Row, Col } from "react-bootstrap";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <Row className="footer-grid">
          
          {/* Left Column - Links */}
          <Col md={6} xs={12}>
            <div className="footer-links">
              <h4>Quick Links</h4>
              <ul>
                <li><Link to="/about">About Us</Link></li>
                {/* <li><Link to="/services">Our Services</Link></li> */}
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
                <li><Link to="/cancellation-policy">Cancellation Policy</Link></li>
                <li><Link to="/refund-policy">Refund Policy</Link></li>
                <li><Link to="/grievance-redressal">Grievance Redressal</Link></li>
                <li><Link to="/contact-us">Contact Us</Link></li>
              </ul>
            </div>
          </Col>

          {/* Right Column - Logo & Info */}
          <Col md={6} xs={12} className="text-md-end text-center">
            <div className="footer-content">
              <div className="footer-logo">
                <img 
                  src="/logo/dharmiq_logo-transparent-mini.png" 
                  alt="Dharmiq Logo" 
                />
              </div>
              <p className="footer-tagline">
                Spirituality • Meditation • Bhakti • Positivity
              </p>
              <div className="copyright">
                © 2026 Dharmiq. All rights reserved.
              </div>
            </div>
          </Col>

        </Row>
      </div>
    </footer>
  );
};

export default Footer;